// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"A_JN1","cta":"_3gf3d","list":"xQBnN","grid":"_2633M","currency":"_1YHvD","askingPrice":"_2DAls","askingPriceLabel":"jKDmX"};